import useSWR from 'swr';

import { fetchSetupProgress, type SetupProgress } from '../data/setupRepository.js';

export const SETUP_PROGRESS_KEY = 'setup/progress';

export type SetupProgressState =
  | { status: 'loading' }
  | { status: 'error'; message: string; retry: () => void }
  | { status: 'ready'; progress: SetupProgress; refresh: () => Promise<unknown> };

/** What the household has declared so far (plan step 1.9). */
export function useSetupProgress(): SetupProgressState {
  const { data, error, isLoading, mutate } = useSWR<SetupProgress, Error>(
    SETUP_PROGRESS_KEY,
    fetchSetupProgress,
    { revalidateOnFocus: false, shouldRetryOnError: false },
  );

  if (error) {
    return {
      status: 'error',
      message: error.message || 'Không đọc được tình trạng thiết lập.',
      retry: () => {
        void mutate();
      },
    };
  }

  if (isLoading || data === undefined) return { status: 'loading' };

  return { status: 'ready', progress: data, refresh: () => mutate() };
}
